import { autumnPromo } from 'reactApp/appHelpers/featuresHelpers/features/autumnPromo';
import { blackFriday2024 } from 'reactApp/appHelpers/featuresHelpers/features/blackFriday2024';
import { blackFriday2025 } from 'reactApp/appHelpers/featuresHelpers/features/blackFriday2025';
import { cyberMonday2025 } from 'reactApp/appHelpers/featuresHelpers/features/cyberMonday2025';
import { logInAccountModalFeature } from 'reactApp/appHelpers/featuresHelpers/features/logInAccountModal';
import { marchPromo2026AnalyticsName } from 'reactApp/appHelpers/featuresHelpers/features/marchPromo2026';
import { mayPromo2025 } from 'reactApp/appHelpers/featuresHelpers/features/mayPromo2025';

export const autumnPromoDwh = autumnPromo ? { name_action: 'autumn_action' } : {};

export const blackFriday2024Dwh = blackFriday2024 ? { name_action: 'black_friday' } : {};

export const cyberMonday2025Dwh = cyberMonday2025 ? { name_action: 'cyber_monday' } : {};

export const mayPromo2025Dwh = mayPromo2025 ? { name_action: 'promo_action_ms_june25' } : {};

export const blackFriday2025Dwh = blackFriday2025 ? { name_action: 'flight_action_blackfriday_1125' } : {};

export const getMarchPromo2026Dwh = (check: boolean) => (check ? { name_action: marchPromo2026AnalyticsName } : {});

export const logInAccountModalDwh = logInAccountModalFeature ? { name_action: 'log_in_account_modal' } : {};
